import React, { useState } from "react";
import { Box, BoxProps } from "@chakra-ui/layout";
import colors from "resources/theme/colors";

interface TabsProps {
  children: React.ReactChild[];
  containerProps?: BoxProps;
}

function Tab({ children, containerProps }: TabsProps) {
  const [selected, setSelected] = useState(0);

  const handleChange = (index: number) => {
    setSelected(index);
  };

  return (
    <div>
      <Box display="flex">
        {children.map((elem: any, index: number) => {
          let actived =
            index === selected
              ? {
                  border: `1px solid ${colors.primary}`,
                  background: colors.primary,
                  color: "#FFFFFF",
                  fontWeight: 700,
                }
              : {
                  background: "#FFF",
                };
          return (
            <Box
              key={index}
              onClick={() => handleChange(index)}
              display={"flex"}
              flex={1}
              justifyContent={"center"}
              p={"15px 0"}
              borderRadius={"16px 16px 0 0"}
              style={{ border: "1px solid #EAEAEA", ...actived }}
              fontSize={14.96}
              cursor={"pointer"}
            >
              {elem.props.title}
            </Box>
          );
        })}
      </Box>

      <Box
        background={"#FFFFFF"}
        borderRadius={"0 0 16px 16px"}
        border={"#EAEAEA 1px solid"}
        p={"25px 24px"}
        {...containerProps}
      >
        {children[selected]}
      </Box>
    </div>
  );
}

export default Tab;
